import i18n from "i18next";
import type { FC } from "react";
import { useSearchParams } from "react-router";

import { getAssignedDataGroup } from "../../../../core/router/auth";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { useLoadConfigQuery } from "../../services/server/formComponentsApi";
import type { SelectDynamicFormField } from "../../types/types";

interface TerminalParameterSelectDynamicValueProps {
    fieldConfig: SelectDynamicFormField;
    value?: string | number;
}

export const TerminalParameterSelectDynamicValue: FC<TerminalParameterSelectDynamicValueProps> = ({ fieldConfig, value }) => {
    const [searchParams] = useSearchParams();

    const {
        urlToFetchOptions,
        optionDisplayPropName = fieldConfig.optionValuePropName ? fieldConfig.optionValuePropName : "key",
        optionValuePropName = fieldConfig.optionValuePropName ? fieldConfig.optionValuePropName : "value",
        queryParams,
        useDataGroup,
    } = fieldConfig;

    let urlToFetch = useDataGroup ? `/${ResourceName.DATA_GROUPS}/${getAssignedDataGroup()?.code}${urlToFetchOptions}` : urlToFetchOptions;

    if (queryParams) {
        const params: Record<string, string> = {};
        queryParams.forEach((param) =>
            Object.keys(param).forEach((urlParam) => {
                params[param[urlParam]] = searchParams.get(urlParam) ?? "";
            }),
        );
        urlToFetch = `${urlToFetch}?${new URLSearchParams(params).toString()}`;
    }

    const { data } = useLoadConfigQuery(urlToFetch, { skip: !urlToFetch || !value });

    if (!value) {
        return null;
    }

    const options = data?.items ?? [];
    // MultiSelectDynamic values arrive already comma-joined (see TerminalsParametersTable), a single value is just one item
    const translatedValues = String(value)
        .split(", ")
        .map((rawValue) => {
            const matchedOption = options.find((option) => String(option[optionValuePropName]) === rawValue);
            return matchedOption ? i18n.t(matchedOption[optionDisplayPropName]) : rawValue;
        });

    return <>{translatedValues.join(", ")}</>;
};
